const PortalCommon = require("./PortalCommon")
const PortalEvent = require("./PortalEvent")
const PortalL10n = require("./PortalL10n")
const PortalStorage = require("./PortalStorage")
const PortalElementBase = require("./PortalElementBase")
const PortalElementSearch = require("./PortalElementSearch")
const PortalConnect = require("./PortalConnect")
const FacetIndex = require("./facetIndex")

// jquery plugins
require('./jquery.selectText')

module.exports = Object.assign({},
  // TODO get rid of those global variables
  {
    PortalCommon,
    PortalStorage,
    PortalL10n,
    PortalEvent,
    PortalElementBase,
    PortalElementSearch,
    PortalConnect,
    FacetIndex,
  })



//////////////////
// WEBPACK FOOTER
// ./js/bundle.js
// module id = 9
// module chunks = 0